import ViewAllButton from "./ViewAllButton";

const VIEW_ALL_BTN_BASE =
    "flex !rounded-[12px] !bg-[#FBFCFD] !border !border-[#EDF0F3] !text-[#343941] !text-[12px] shrink-0 whitespace-nowrap";

/** Compact View All for tab bar row (desktop) */
const TAB_VIEW_ALL_BTN =
    "flex !rounded-[12px] !bg-[#FBFCFD] !border !border-[#EDF0F3] !text-[#343941] !text-[11px] !px-3 !py-1.5 shrink-0 whitespace-nowrap";

/** Bottom padding for sliders with arrow controls (dots + nav buttons) */
export const CAROUSEL_SLIDER_PAD = "pb-[0px] md:pb-[58px]";

/** Header row: reserves right space so View All does not overlap slider arrows */
export const CAROUSEL_HEADER_ROW_CLASS =
    "flex items-center justify-between gap-4 mb-4 md:mb-6";

interface CarouselViewAllProps {
    href: string;
    title: string;
    label?: string;
    className?: string;
}

export function CarouselViewAllHeader({
    href,
    title,
    label,
    className = "",
}: CarouselViewAllProps) {
    return (
        <ViewAllButton
            href={href}
            title={title}
            label={label}
            className={`${VIEW_ALL_BTN_BASE} hidden md:inline-flex ${className}`}
            iconClass="invert"
        />
    );
}

/** View All aligned with tab row — compact size for desktop tab bar */
export function TabViewAllHeader({
    href,
    title,
    className = "",
}: CarouselViewAllProps) {
    return (
        <ViewAllButton
            href={href}
            title={title}
            className={`${TAB_VIEW_ALL_BTN} hidden md:inline-flex ${className}`}
            iconClass="invert"
        />
    );
}

export function CarouselViewAllFooter({
    href,
    title,
    label,
    className = "",
    wrapperClassName = "mt-6",
}: CarouselViewAllProps & { wrapperClassName?: string }) {
    return (
        <div className={`text-center block md:hidden ${wrapperClassName}`}>
            <ViewAllButton
                href={href}
                title={title}
                label={label}
                className={`${VIEW_ALL_BTN_BASE} inline-flex ${className}`}
                iconClass="invert"
            />
        </div>
    );
}
